import { createFileRoute } from "@tanstack/react-router";
import { QueuesTable } from "../-components/queues-table";
import { useQuery } from "@tanstack/react-query";
import { queueGroupQueuesQueryOptions } from "@/server/queues";
import { ResponsiveFormSection } from "@/components/form/responsive-form";
import { useEffect } from "react";
import { ContextUser } from "@/lib/utils";
export const Route = createFileRoute("/_dashboard/queue-groups/$queueGroupId/queues")({
  component: RouteComponent,
  loader: async ({ params, context }) => {
    return {
      queueGroupId: params.queueGroupId,
      crumb: "Queues",
      user: context.user as ContextUser | null | undefined,
    };
  },
});

function RouteComponent() {
  const { queueGroupId, user } = Route.useLoaderData();
  const queueGroupQueuesQuery = useQuery(queueGroupQueuesQueryOptions(Number(queueGroupId)));
  const queueGroupQueues = queueGroupQueuesQuery.data;

  useEffect(() => {
    if (!queueGroupId) return;
    void queueGroupQueuesQuery.refetch();
  }, [queueGroupId, queueGroupQueuesQuery.refetch]);

  return (
    <ResponsiveFormSection>
      <QueuesTable
        queues={queueGroupQueues}
        isLoading={queueGroupQueuesQuery.isLoading}
        queueGroupId={Number(queueGroupId)}
        user={user}
      />
    </ResponsiveFormSection>
  );
}
